(function () {
  if (window.__cwWishlistBooted) return;
  window.__cwWishlistBooted = true;

  var KEY = 'cw_wishlist_v1';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(arr) {
    localStorage.setItem(KEY, JSON.stringify(arr));
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { items: arr } }));
  }

  var api = {
    all: read,
    has: function (h) { return read().indexOf(h) !== -1; },
    add: function (h) { var a = read(); if (a.indexOf(h) === -1) { a.unshift(h); write(a); } },
    remove: function (h) { write(read().filter(function (x) { return x !== h; })); },
    toggle: function (h) { api.has(h) ? api.remove(h) : api.add(h); return api.has(h); },
    clear: function () { write([]); }
  };
  window.CustomWishlist = api;

  function syncButtons(root) {
    root = root || document;
    root.querySelectorAll('[data-wishlist-button]').forEach(function (btn) {
      var on = api.has(btn.dataset.handle);
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? btn.dataset.labelRemove : btn.dataset.labelAdd);
      var label = btn.querySelector('[data-wishlist-label]');
      if (label) label.textContent = on ? btn.dataset.labelRemove : btn.dataset.labelAdd;
    });

    var count = api.all().length;

    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
    });

    document.querySelectorAll('[data-wishlist-dot]').forEach(function (el) {
      el.hidden = count === 0;
    });

    document.querySelectorAll('.header__wishlist-link').forEach(function (el) {
      el.classList.toggle('is-active', count > 0);
    });
  }
  window.__cwSyncWishlist = syncButtons;

  // Click delegation — cards re-render hone ke baad bhi kaam karega
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-button]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    api.toggle(btn.dataset.handle);
  });

  document.addEventListener('wishlist:updated', function () { syncButtons(); });
  document.addEventListener('shopify:section:load', function () { syncButtons(); });
  document.addEventListener('DOMContentLoaded', function () { syncButtons(); });

  // Prestige quick-view / infinite scroll / facet re-render ke baad re-sync
  var t;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(function () { syncButtons(); }, 100);
  }).observe(document.documentElement, { childList: true, subtree: true });

  syncButtons();
})();